import { EntityTypes } from 'constants/entities';
import { PortraitState } from 'core/slices/player';
import { select } from 'redux-saga/effects';
import { createSelector } from 'reselect';
import { RootState } from '../../../types';
import { selectSession } from './session';

const portrait = (state: RootState) => state.core.player.state.portrait;

export const selectPortrait = createSelector([portrait], portrait => {
  return portrait !== PortraitState.NOT_PORTRAIT;
});

export const selectPortraitState = createSelector([portrait], portrait => {
  return portrait;
});
